import { Route, Switch } from 'react-router-dom';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import Footer from './components/Footer';
import Header from './components/Header';
import Map from './components/Map';
import { Menu } from './components/Menu';
import OpeningHours from './components/OpeningHours';
import firebase from 'firebase/app';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column nowrap',
      background: theme.palette.grey[100],
    },
  })
);

interface IOwnProps {
  firebase: typeof firebase;
}

export const App: React.FC<IOwnProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.appWrapper}>
      <Header />
      <Switch>
        <Route path='/menu'>
          <Menu firebase={firebase} />
        </Route>
        <Route path='/'>
          <OpeningHours />
        </Route>
      </Switch>
      <Map />
      <Footer />
    </div>
  );
};

export default App;
